import { request } from "./api";

const DEFAULT_SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",
  x: "https://x.com/",
  tiktok: "https://www.tiktok.com/",
};

const EMPTY_SITE_CONTENT = {
  brand: {
    name: "Apparify",
    tagline:
      "Shop apparel from participating stores in Cavite with a storefront that stays connected to orders, fulfillment, and customer support.",
    shortDescription:
      "Browse products, place orders, manage purchases, and stay updated through a shopper experience that works closely with store operations.",
  },
  company: {
    legalName: "Apparify",
    supportEmail: null,
    supportPhone: null,
    supportHours: null,
    supportAddress: null,
  },
  socialLinks: {
    ...DEFAULT_SOCIAL_LINKS,
  },
};

function normalizeSiteContent(raw = {}) {
  return {
    brand: {
      ...EMPTY_SITE_CONTENT.brand,
      ...(raw?.brand || {}),
    },
    company: {
      ...EMPTY_SITE_CONTENT.company,
      ...(raw?.company || {}),
    },
    socialLinks: {
      ...EMPTY_SITE_CONTENT.socialLinks,
      ...(raw?.socialLinks || {}),
    },
  };
}

export async function fetchSiteContent(options = {}) {
  const data = await request({
    url: "/api/site/content",
    method: "GET",
    signal: options.signal,
  });

  return normalizeSiteContent(data?.data || {});
}

export { EMPTY_SITE_CONTENT };
